const rules: any = {
    name: [{ required: true, message: "Category name is required" }],
};

  export default rules;